import { LoaderComponent } from './../loader/loader.component';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { HotelRoutingModule } from './hotel-routing.module';
import { HotelComponent } from './hotel.component';
import { OwlModule } from 'ngx-owl-carousel';
import { FormsModule } from '@angular/forms';
import { TypeaheadModule } from 'ngx-bootstrap/typeahead';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { HotelResultComponent } from '../hotel-result/hotel-result.component';
import { Ng5SliderModule } from 'ng5-slider';
import { HotelDetailComponent } from '../hotel-detail/hotel-detail.component'
import { ModalModule } from 'ngx-bootstrap/modal';
import { HotelPassengerComponent } from '../hotel-passenger/hotel-passenger.component';
import { HotelConfirmationComponent } from '../hotel-confirmation/hotel-confirmation.component';
import { VoucherComponent } from '../voucher/voucher.component';
import { InvoiceComponent } from '../invoice/invoice.component';
import { HotelPaymentConfirmationComponent } from '../hotel-payment-confirmation/hotel-payment-confirmation.component';
import { HotellistloaderComponent } from '../hotellistloader/hotellistloader.component';
import { MatProgressBarModule } from '@angular/material';
import { SlickCarouselModule } from 'ngx-slick-carousel';
import { FormatTimePipe } from '../Pipe/format-time.pipe';
import { HotelPaymentDeclinedComponent } from './hotel-payment-declined/hotel-payment-declined.component';


@NgModule({
  declarations: [HotelComponent, HotelResultComponent, HotelDetailComponent,
    HotelPassengerComponent, HotelConfirmationComponent, LoaderComponent, VoucherComponent
    , InvoiceComponent, HotelPaymentConfirmationComponent, HotellistloaderComponent, FormatTimePipe, HotelPaymentDeclinedComponent],
  imports: [
    CommonModule,
    HotelRoutingModule,
    OwlModule,
    FormsModule,
    TypeaheadModule.forRoot(),
    BsDatepickerModule.forRoot(),
    Ng5SliderModule,
    ModalModule.forRoot(),
    MatProgressBarModule,
    SlickCarouselModule,
  ],
  exports: [LoaderComponent, FormatTimePipe]
})
export class HotelModule { }
